import { alpha, Toolbar, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { CommonTexts } from 'locale/es';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

function TableToolbar({ title, numSelected, handleShowDeleteDialog, handleShowDuplicateDialog }) {
  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          {title}
        </Typography>
      )}

      {numSelected > 0 && (
        <>
          {handleShowDeleteDialog && (
            <Tooltip title={CommonTexts.DELETE}>
              <IconButton onClick={handleShowDeleteDialog}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          )}
          {handleShowDuplicateDialog && (
            <Tooltip title={CommonTexts.DUPLICATE}>
              <IconButton onClick={handleShowDeleteDialog}>
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      )}
    </Toolbar>

  );
}

TableToolbar.propTypes = {
  title: PropTypes.string.isRequired,
  numSelected: PropTypes.number.isRequired,
};

export default TableToolbar